import { Component, signal } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { NavigationService } from '../../../../services/navigation.service';
import { Lesson } from '@mira-avant/mtlibs';
import { LessonService } from '../../../../services/lesson.service';
import { CarouselTitleComponent } from './carousel-title/carousel-title.component';
import { CarouselDescriptionComponent } from './carousel-description/carousel-description.component';
import { PathActivitySelectorComponent } from './path-activity-selector/path-activity-selector.component';

@Component({
	selector: 'app-carousel',
	standalone: true,
	imports: [
		AngularModule,
		ZorroModule,
		CarouselTitleComponent,
		CarouselDescriptionComponent,
		PathActivitySelectorComponent,
	],
	templateUrl: './carousel.component.html',
	styleUrl: './carousel.component.scss',
})
export class CarouselComponent {
	public lesson = signal<Lesson | undefined>(undefined);
	public loading = signal(true);

	constructor(
		public nav: NavigationService,
		public lessonService: LessonService
	) {}

	async ngOnInit(): Promise<void> {
		const matrixParams = await this.nav.matrixParams$.getValue();

		const lessonUuid = matrixParams['lessonUuid'];

		try {
			const fetchedLesson = await this.lessonService.get$(lessonUuid, true);
			this.lesson.set(fetchedLesson);
		} catch (error: unknown) {
			console.error(error);
		} finally {
			this.loading.set(false);
		}
	}
}
